module.exports = __webpack_public_path__ + "static/media/youtube icon.f0e37894.svg";